<template>
  <div class="wrapper padding-lr-sm">
    <div class="flex align-center justify-between margin-bottom-sm">
      <div class="flex align-center ">
        <el-input v-model="keyword" placeholder="请输入专家姓名" class=" margin-right-sm"></el-input>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <div>
        <el-select v-model="chioseExpert" multiple filterable placeholder="请选择专家" class="margin-right-sm">
          <el-option
            v-for="item in chioseExpertList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" round @click="addEstimateExpert">添加至参评专家</el-button>
      </div>


    </div>

    <el-table
      :data="expertList"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
      <el-table-column width="120" label="姓名" prop="name" align="center"></el-table-column>
      <el-table-column width="120" label="手机号" prop="phone" align="center"></el-table-column>
      <el-table-column label="简介">
        <template slot-scope="scope">
          <p class="ovHide3">{{ scope.row.remark }}</p>
        </template>
      </el-table-column>
      <el-table-column width="140" label="评估机构数量" prop="org_num" align="center"></el-table-column>
      <el-table-column width="240" label="操作">
        <template slot-scope="scope">
          <div class="table-operate">
            <div class="flex align-center justify-between">
              <router-link to="">
                <el-button size="medium" type="primary" @click="getItemOrg(scope.row.id,scope.row.name)">设置参评机构
                </el-button>
              </router-link>
              <el-button size="medium" type="danger" @click="deleteItem(scope.row.id)">删除</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="expertList.length > 0"
      class="page-all"
      background
      @current-change="getList"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <expertChioseOrg
      :orgDialog="orgDialog"
      :setId="setId"
      :setName="setName"
      @cancelDialog="getList"
    />
  </div>
</template>

<script>
import {
  getExpertList,
  getEstimateExpertList,
  delEstimateExpert,
  expertToScore,
  playDetail
} from "@/api/admin";
import expertChioseOrg from "@/views/admin/dialog/expertChioseOrg";

export default {
  name: "estimateExpert",
  data() {
    return {
      id: '',
      keyword: '',
      page: 1,
      limit: 10,
      total: 0,
      expertList: [],
      chioseExpert: [],
      chioseExpertList: [],
      orgDialog: false,
      setId: 0,
      setName: '',
    }
  },
  created() {
    this.$emit("setIndex", '/admin/scoreList', "参评专家管理", true);
    this.id = this.$route.params.id
    this.getInfo()
    this.getList()
  },
  components: {expertChioseOrg},
  methods: {
    //  获取专家下的参评机构
    async getItemOrg(id, name) {
      this.setId = id
      this.setName = name
      this.orgDialog = true
    },
    //  删除
    deleteItem(id) {
      this.$confirm('您确定要删除该参评专家吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delEstimateExpert(id);
      if (this.expertList.length === 1 && this.page > 1) {
        this.page--;
      }
      await this.getList();
      this.$message.success(_state.msg);
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getList()
    },
    //  添加专家至评估表中
    async addEstimateExpert() {
      if (this.chioseExpert.length === 0) return this.$message.error('请选择参评专家')
      const state = await expertToScore(this.id, this.chioseExpert.join(','))
      if (state.status === 200) {
        this.$message.success('添加成功')
        this.getList()
        this.chioseExpert = []
      }
    },
    //  获取专家表列表
    async getList() {
      this.orgDialog = false
      const res = await getEstimateExpertList(this.id, this.keyword, this.page, this.limit)
      const list = await getExpertList(this.id)
      this.expertList = res.data.data
      this.total = res.data.total
      this.chioseExpertList = list.data
    },
    //  获取评估表基本信息
    async getInfo() {
      const res = await playDetail(this.id)
      const title = `${res.data.playingData.year} - ${res.data.playingData.name} - 参评专家管理`
      this.$emit("setIndex", '/admin/scoreList', title, true);
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
